/* eslint-disable simple-import-sort/imports */

import rangy from 'rangy';

import 'rangy/lib/rangy-classapplier';
import 'rangy/lib/rangy-highlighter';
import 'rangy/lib/rangy-textrange';

import { Rangy, RangyDomPosition } from '../types/rangy';

export const getDomPosition = (
  ...args: [RangyDomPosition['node'], RangyDomPosition['offset']]
): RangyDomPosition => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-type-assertion -- rangy.dom.DomPosition is an internal Rangy class not in the type definitions; cast through any required to instantiate it
  return new (rangy as any).dom.DomPosition(...args) as RangyDomPosition;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- the rangy library's TS types don't match our Rangy interface; this bridges the untyped import to our typed wrapper
export default rangy as unknown as Rangy;
